/* global SystemMessages, Option */

window['companies#edit'] = function () {
  SystemMessages.editable_fields()

  $(document).on('change', '#company_available_locales', function () {
    const locales = $(this).val()
    const defaultLocaleSelect = $('#company_default_locale')
    defaultLocaleSelect.empty()

    locales.forEach(locale => {
      defaultLocaleSelect.append(new Option(locale, locale))
    })
  })
}
